import React, { Component } from "react";
import HomePV from "./HomePV";
import AuthA from "../../store/actions/AuthA";
import QuarterA from "../../store/actions/QuarterA";
import { connect } from "react-redux";

import axios from "axios";
import find from "lodash/find";
import { getCurrentQuarter } from "../../utils/quarterUtils";

const _ = {
  find: find,
};

class HomePC extends Component {
  constructor(props) {
    super(props);
    this.state = {
      perSubjectSummary: [],
      perSectionSummary: [],
      perLevelSummary: [],
      perQuarterSummary: [],
      perSubjectSummaryConducts: [],
      perSectionSummaryConducts: [],
      perLevelSummaryConducts: [],
      perQuarterSummaryConducts: [],
      schoolYears: [],
      currentSchoolYear: "",
      schoolYearId: "",
      loadedSubject: false,
      loadedClass: false,
      loadedLevel: false,
      loadedQuarter: false,
      activeButton: "subject",

      details: [],
      detailsAdmin: [],
      searchKey: "",
      activePage: 1,
      itemPerPage: 5,
      selectedIndex: 0,
      openConfirm: false,
      link: "",
      teacherId: "",
    };
    this.onSearchChange = this.onSearchChange.bind(this);
    this.handlePaginationChange = this.handlePaginationChange.bind(this);
  }

  getSubjectSummary = async () => {
    await axios
      .get(
        `${process.env.REACT_APP_URL}/sectionSubjects/summary/grades/subject?teacherId=${this.props.userId}&schoolYearId=${this.props.schoolYearId}&quarter=${this.props.currentQuarter}`
      )
      .then((response) => {
        this.setState({
          perSubjectSummary: response.data,
          loadedSubject: true,
        });
      });
  };

  getClassSummary = async () => {
    await axios
      .get(
        `${process.env.REACT_APP_URL}/sectionSubjects/summary/grades/class?teacherId=${this.props.userId}&schoolYearId=${this.props.schoolYearId}&quarter=${this.props.currentQuarter}`
      )
      .then((response) => {
        this.setState({ perSectionSummary: response.data, loadedClass: true });
      });
  };

  getLevelSummary = async () => {
    await axios
      .get(
        `${process.env.REACT_APP_URL}/sectionSubjects/summary/grades/level?levelType=${this.props.levelType}&schoolYearId=${this.props.schoolYearId}&quarter=${this.props.currentQuarter}`
      )
      .then((response) => {
        this.setState({ perLevelSummary: response.data, loadedLevel: true });
      });
  };

  getQuarterSummary = async () => {
    await axios
      .get(
        `${process.env.REACT_APP_URL}/sectionSubjects/summary/grades/admin?userType=${this.props.userType}&schoolYearId=${this.props.schoolYearId}&quarter=${this.props.currentQuarter}`
      )
      .then((response) => {
        this.setState({
          perQuarterSummary: response.data,
          loadedQuarter: true,
        });
      });
  };

  getSubjectSummaryConducts = async () => {
    await axios
      .get(
        `${process.env.REACT_APP_URL}/sectionSubjects/summary/conducts/subject?teacherId=${this.props.userId}&schoolYearId=${this.props.schoolYearId}&quarter=${this.props.currentQuarter}`
      )
      .then((response) => {
        this.setState({ perSubjectSummaryConducts: response.data });
      });
  };

  getClassSummaryConducts = async () => {
    await axios
      .get(
        `${process.env.REACT_APP_URL}/sectionSubjects/summary/conducts/class?teacherId=${this.props.userId}&schoolYearId=${this.props.schoolYearId}&quarter=${this.props.currentQuarter}`
      )
      .then((response) => {
        this.setState({ perSectionSummaryConducts: response.data });
      });
  };

  getLevelSummaryConducts = async () => {
    await axios
      .get(
        `${process.env.REACT_APP_URL}/sectionSubjects/summary/conducts/level?levelType=${this.props.levelType}&schoolYearId=${this.props.schoolYearId}&quarter=${this.props.currentQuarter}`
      )
      .then((response) => {
        this.setState({ perLevelSummaryConducts: response.data });
      });
  };

  getQuarterSummaryConducts = async () => {
    await axios
      .get(
        `${process.env.REACT_APP_URL}/sectionSubjects/summary/conducts/admin?userType=${this.props.userType}&schoolYearId=${this.props.schoolYearId}&quarter=${this.props.currentQuarter}`
      )
      .then((response) => {
        this.setState({ perQuarterSummaryConducts: response.data });
      });
  };

  getSectionLevelSummary = async () => {
    await axios
      .get(
        `${process.env.REACT_APP_URL}/sections/details/level?levelType=${this.props.levelType}&schoolYearId=${this.props.schoolYearId}&quarter=${this.props.currentQuarter}`
      )
      .then((response) => {
        this.setState({ details: response.data.details });
      });
  };

  getSectionAdminSummary = async () => {
    await axios
      .get(
        `${process.env.REACT_APP_URL}/sections/details/admin?userType=${this.props.userType}&schoolYearId=${this.props.schoolYearId}&quarter=${this.props.currentQuarter}`
      )
      .then((response) => {
        this.setState({ detailsAdmin: response.data.details });
      });
  };

  getSchoolYears = async () => {
    await axios
      .get(
        process.env.REACT_APP_URL + "/schoolyears?filter[where][active]=true"
      )
      .then((response) => {
        const currentSchoolYear = _.find(response.data, {
          isCurrent: true,
        });
        const currentQuarter = getCurrentQuarter();
        
        // Initialize quarter in Redux store
        this.props.quarterActions.setSchoolYearId(currentSchoolYear.schoolYearId);
        this.props.quarterActions.setSchoolYear(currentSchoolYear.schoolYear);
        this.props.quarterActions.setCurrentQuarter(currentQuarter);
        
        this.setState(
          {
            schoolYears: response.data,
            currentSchoolYear: currentSchoolYear,
          },
          function () {
            if (
              this.props.userType === "admin" ||
              this.props.userType === "principal" ||
              this.props.userType === "registrar"
            ) {
              this.setState({ activeButton: "all" }, () => {
                this.getSectionAdminSummary();
                this.getSectionLevelSummary();

                this.getQuarterSummary();
                this.getLevelSummary();
                this.getQuarterSummaryConducts();
                this.getLevelSummaryConducts();

                this.getClassSummary();
                this.getSubjectSummary();
                this.getClassSummaryConducts();
                this.getSubjectSummaryConducts();
              });
            } else if (this.props.userType === "levelHead") {
              this.setState({ activeButton: "level" }, () => {
                this.getSectionLevelSummary();
                this.getLevelSummary();
                this.getLevelSummaryConducts();

                this.getClassSummary();
                this.getSubjectSummary();
                this.getClassSummaryConducts();
                this.getSubjectSummaryConducts();
              });
            } else if (this.props.userType === "adviser") {
              this.setState({ activeButton: "section" }, () => {
                this.getSubjectSummary();
                this.getClassSummary();

                this.getSubjectSummaryConducts();
                this.getClassSummaryConducts();
              });
            } else if (this.props.userType === "teacher") {
              this.setState({ activeButton: "subject" }, () => {
                this.getSubjectSummary();
                this.getSubjectSummaryConducts();
              });
            } else {
              this.setState({ activeButton: "none" });
            }
          }
        );
      });
  };

  isSearched(searchKey) {
    return function (item) {
      return (
        !searchKey ||
        item.section.name.toLowerCase().includes(searchKey.toLowerCase()) ||
        item.section.gradeLevel.toLowerCase().includes(searchKey.toLowerCase())
      );
    };
  }

  onSearchChange(event) {
    this.setState({ searchKey: event.target.value });
  }

  openConfirmation = (link, teacherId) =>
    this.setState({
      openConfirm: true,
      link: link,
      teacherId: teacherId,
    });

  closeConfirmation = () =>
    this.setState({
      openConfirm: false,
      link: "",
      teacherId: "",
    });

  handlePaginationChange(e, { activePage }) {
    this.setState({
      activePage: activePage,
    });
  }

  handleChangeSchoolYear = (e, { value }) => {
    const selectedSchoolYear = _.find(this.state.schoolYears, { schoolYearId: value });
    this.props.quarterActions.setSchoolYearId(value);
    this.props.quarterActions.setSchoolYear(selectedSchoolYear.schoolYear);
    
    // Refresh data with new school year
    if (
      this.props.userType === "admin" ||
      this.props.userType === "principal" ||
      this.props.userType === "registrar"
    ) {
      this.getSubjectSummary();
      this.getClassSummary();
      this.getLevelSummary();
      this.getQuarterSummary();

      this.getSubjectSummaryConducts();
      this.getClassSummaryConducts();
      this.getLevelSummaryConducts();
      this.getQuarterSummaryConducts();

      this.getSectionLevelSummary();
      this.getSectionAdminSummary();
    } else if (this.props.userType === "levelHead") {
      this.getSubjectSummary();
      this.getClassSummary();
      this.getLevelSummary();

      this.getSubjectSummaryConducts();
      this.getClassSummaryConducts();
      this.getLevelSummaryConducts();

      this.getSectionLevelSummary();
    } else if (this.props.userType === "adviser") {
      this.getSubjectSummary();
      this.getClassSummary();

      this.getSubjectSummaryConducts();
      this.getClassSummaryConducts();
    } else if (this.props.userType === "teacher") {
      this.getSubjectSummary();
      this.getSubjectSummaryConducts();
    } else {
      this.setState({ activeButton: "none" });
    }
  };

  handleChangeQuarter = (e, { value }) => {
    this.props.quarterActions.setCurrentQuarter(value);
    
    // Refresh data with new quarter
    if (
      this.props.userType === "admin" ||
      this.props.userType === "principal" ||
      this.props.userType === "registrar"
    ) {
      this.getSubjectSummary();
      this.getClassSummary();
      this.getLevelSummary();
      this.getQuarterSummary();

      this.getSubjectSummaryConducts();
      this.getClassSummaryConducts();
      this.getLevelSummaryConducts();
      this.getQuarterSummaryConducts();

      this.getSectionLevelSummary();
      this.getSectionAdminSummary();
    } else if (this.props.userType === "levelHead") {
      this.getSubjectSummary();
      this.getClassSummary();
      this.getLevelSummary();

      this.getSubjectSummaryConducts();
      this.getClassSummaryConducts();
      this.getLevelSummaryConducts();

      this.getSectionLevelSummary();
    } else if (this.props.userType === "adviser") {
      this.getSubjectSummary();
      this.getClassSummary();

      this.getSubjectSummaryConducts();
      this.getClassSummaryConducts();
    } else if (this.props.userType === "teacher") {
      this.getSubjectSummary();
      this.getSubjectSummaryConducts();
    } else {
      this.setState({ activeButton: "none" });
    }
  };

  handleClick = (item) => {
    this.setState({ activeButton: item, searchKey: "" });
  };

  handleNotify = () => {
    const { link, teacherId } = this.state;
    const url = process.env.REACT_APP_URL + "/notifications";
    const data = {
      link: link,
      teacherId: teacherId,
      from: this.props.username,
    };
    axios
      .request({
        method: "post",
        url: url,
        data: data,
      })
      .then((response) => {
        console.log(response.data);
        this.closeConfirmation();
      })
      .catch((err) => console.log(err));
  };

  openToDo = () => {
    console.log("open");
  };

  componentDidMount() {
    this.props.authFn.getToken();
    this.props.onContentMount({ title: "Home" });
    this.getSchoolYears();
  }

  componentWillReceiveProps(newProps) {
    newProps.authFn.getToken();
    this.getSchoolYears();
  }

  render() {
    return (
      <HomePV
        auth={this.props.auth}
        userType={this.props.userType}
        levelType={this.props.levelType}
        perSubjectSummary={this.state.perSubjectSummary}
        perSectionSummary={this.state.perSectionSummary}
        perLevelSummary={this.state.perLevelSummary}
        perQuarterSummary={this.state.perQuarterSummary}
        perSubjectSummaryConducts={this.state.perSubjectSummaryConducts}
        perSectionSummaryConducts={this.state.perSectionSummaryConducts}
        perLevelSummaryConducts={this.state.perLevelSummaryConducts}
        perQuarterSummaryConducts={this.state.perQuarterSummaryConducts}
        quarter={this.props.currentQuarter}
        loadedSubject={this.state.loadedSubject}
        loadedClass={this.state.loadedClass}
        loadedLevel={this.state.loadedClass}
        loadedQuarter={this.state.loadedQuarter}
        schoolYearId={this.props.schoolYearId}
        schoolYears={this.state.schoolYears}
        activeButton={this.state.activeButton}
        details={this.state.details}
        detailsAdmin={this.state.detailsAdmin}
        searchKey={this.state.searchKey}
        activePage={this.state.activePage}
        itemPerPage={this.state.itemPerPage}
        openConfirm={this.state.openConfirm}
        isSearched={this.isSearched}
        onSearchChange={this.onSearchChange}
        openConfirmation={this.openConfirmation}
        closeConfirmation={this.closeConfirmation}
        handleNotify={this.handleNotify}
        handlePaginationChange={this.handlePaginationChange}
        handleChangeSchoolYear={this.handleChangeSchoolYear}
        handleChangeQuarter={this.handleChangeQuarter}
        handleClick={this.handleClick}
        openToDo={this.openToDo}
      />
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    authFn: AuthA(dispatch),
    quarterActions: QuarterA(dispatch),
  };
};

const mapStateToProps = (state) => {
  return {
    auth: state.AuthR.auth,
    userType: state.AuthR.userType,
    userId: state.AuthR.userId,
    levelType: state.AuthR.levelType,
    username: state.AuthR.username,
    currentQuarter: state.QuarterR.currentQuarter,
    schoolYear: state.QuarterR.schoolYear,
    schoolYearId: state.QuarterR.schoolYearId,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HomePC);
